const canHideSplashScreen = ref(false)

const setCanHideSplashScreen = (newState: boolean) => {
  canHideSplashScreen.value = newState
}

export const useSplashScreenState = () => {
  return {
    canHideSplashScreen: readonly(canHideSplashScreen),
    setCanHideSplashScreen,
  }
}
